import React, { useState } from 'react';

interface NearbyGuest {
  id: number;
  firstName: string;
  lastName?: string;
  commonTagsCount: number;
  tags: string[];
  hasResponded: boolean;
}

interface NearbyGuestsStepProps {
  nearbyGuests: NearbyGuest[];
  selectedIds: Set<number>;
  onToggle: (id: number) => void;
  onContinue: () => void;
}

const NearbyGuestsStep: React.FC<NearbyGuestsStepProps> = ({
  nearbyGuests,
  selectedIds,
  onToggle,
  onContinue,
}) => {
  const [visibleCount, setVisibleCount] = useState(3);
  const displayedGuests = nearbyGuests.slice(0, visibleCount);
  const remainingCount = nearbyGuests.length - visibleCount;
  const hasMore = remainingCount > 0;

  const handleShowMore = () => {
    setVisibleCount((prev) => prev + 3);
  };

  return (
    <>
      <div className="card-header">
        <h2>Voulez-vous répondre pour d'autres personnes ?</h2>
        <p className="card-subtitle">Vous pouvez également répondre pour ces personnes :</p>
      </div>

      <div className="nearby-guests-tags">
        {displayedGuests.map((guest) => (
          <button
            key={guest.id}
            type="button"
            className={`nearby-guest-tag ${selectedIds.has(guest.id) ? 'selected' : ''} ${guest.hasResponded ? 'responded' : ''}`}
            onClick={() => onToggle(guest.id)}
          >
            <span className="tag-name">
              {guest.firstName} {guest.lastName || ''}
            </span>
            {guest.hasResponded && (
              <span className="tag-badge">Déjà répondu</span>
            )}
          </button>
        ))}
        {hasMore && (
          <button
            type="button"
            onClick={handleShowMore}
            className="see-more-btn"
          >
            Voir plus ({remainingCount} autre{remainingCount > 1 ? 's' : ''})
          </button>
        )}
      </div>

      <button onClick={onContinue} className="modern-btn primary full-width">
        Continuer
      </button>
    </>
  );
};

export default NearbyGuestsStep;
